import { Button, Result } from 'antd'
import React from 'react'

interface ErrorBoundaryState {
  error: Error | null
}

export const createErrorBoundary = (alert: (message: any) => void) => {
  return class ErrorBoundary extends React.Component {
    state: ErrorBoundaryState = { error: null }

    static getDerivedStateFromError(error: Error) {
      return { error }
    }

    onRefresh = () => {
      window.location.href = '/'
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
      alert({
        error: error.message,
        url: window.location.href,
        errorInfo: {
          ...errorInfo,
          componentStack: errorInfo?.componentStack?.slice(0, 300),
        },
      })
    }

    render() {
      if (this.state.error) {
        return (
          <Result
            status='500'
            title='Error'
            subTitle={this.state.error.message || ''}
            extra={
              <Button type='primary' onClick={this.onRefresh}>
                Refresh
              </Button>
            }
          />
        )
      }
      return this.props.children
    }
  }
}
